import React, { Component } from 'react'
import { Button, TextInput, Checkbox, Loading, Link } from 'carbon-components-react'
import LogInAPI from '../api/LogInAPI'
import RememberMeAPI from '../api/RememberMeAPI'
import UrlBuilder from '../shared/urlBuilder/UrlBuilder'
import LogInErrors from '../data/LogInErrors.json'
import ReactHtmlParser from 'react-html-parser'
import PropTypes from 'prop-types'
import { LiveAnnouncer, LiveMessage } from 'react-aria-live'
import LogInFooter from './LogInFooter'
import ErrorMessageIcon from '../../globals/images/icon-error-message.svg'
import passwordUtils from '../../utils/inputTextPasswordUtils'
import { trackEventMessage, trackEventMessageFailure } from '../../TelemetryService'
import { FF_MFA_SHOW_MESSAGE_ENABLED, LOGIN, LOGIN_PKCE, MFA_STATUS, PERSONALIZED_COOKIE_NAME, PersonalizedCookieStateCodeProperty } from '../../constants'
import { EventModel } from './../../models/EventModel'
import { withOktaAuth } from '@okta/okta-react'
import { withLDConsumer } from 'launchdarkly-react-client-sdk'
import { MfaWizard } from '../mfaWizard/MfaWizard'
import { MFADomain } from '../domain/mfa.services'
import { MFA, MFASteps } from '../mfaWizard/MFASteps'
import { refreshLDContextAndGetFFValue } from '../shared/launchDarklyHelper/launchDarkly'
import { getCookieValueByKey } from '../../utils/cookieUtils'
import { getMfaRememberMeLocalStorageValue, removeAskMeLaterLocalStorageItem, setMfaOktaUsernameLocalStorageValue, setUserLoginValueOnSessionStorage } from '../../utils/localStorageUtils'
import { createSha256Hash } from '../../utils/cryptographyUtils'
import { AdobeAnalytics } from '../../utils/adobe-analytics'

export default withLDConsumer()( withOktaAuth( class LogIn extends Component  {
    _isMounted = false
    
    constructor() {
        super()
        this.state = {
            webId: '',
            oktaUserName: '',
            debounce: false,
            password: '',
            rememberMe: false,
            errors: null,
            allowUserId: false,
            loading: false,
            enableSignUp: true,
            title: 'Sign in',
            formatError: null,
            displayCompleteADAMsg : true,
            partialADAMsg: 'Email or Username',
            showMFAWizard: false,
            loginResponseReturnUrl: '',
            userId: '',
            phoneNumber: '',
            mfaStep: MFASteps.AskMeAgain,
            factors: [],
            errorMessages: [],
            lastErrorMessages: []
        }

        this.handleChangeUserId = this.handleChangeUserId.bind( this )
        this.handleChangePassword = this.handleChangePassword.bind( this )
        this.handleChangeRemember = this.handleChangeRemember.bind( this )
        this.handleSubmit = this.handleSubmit.bind( this )
        this.renderErrors = this.renderErrors.bind( this )
        this.renderTextError = this.renderTextError.bind( this )
        this.validateLength = this.validateLength.bind( this )
        this.hasLoggedError = false
    }

    get config() {
        return this.props.config || {}
    }

    get logInApiUrl() {
        return this.config.logInApiUrl || process.env.REACT_APP_LOG_IN_API_URL 
    }

    get forgotPasswordUrl() {
        return this.config.forgotPasswordUrl || process.env.REACT_APP_FORGOT_PASSWORD
    }
    get rememberMeUrl() {
        return this.config.rememberMeUrl || process.env.REACT_APP_REMEMBER_ME
    }

    get registerUrl() {
        return this.config.registerUrl || process.env.REACT_APP_REGISTER
    }
    
    get contractorsUrl() {
      return this.config.contractorsUrl || process.env.REACT_APP_CONTRACTORS
    }

    get municipalUrl() {
        return this.config.municipalUrl || process.env.REACT_APP_MUNICIPAL
    }

    get dgContractorsUrl() {
        return this.config.dgContractorsUrl || process.env.REACT_APP_DGCONTRACTORS
    }

    get returnUrl() {
        const searchParams = new URLSearchParams( location.search )
        const searchReturnUrl = searchParams.get( 'ReturnUrl' ) || ''
        const hash = location.hash || ''
        const returnUrl = `${ searchReturnUrl }${ hash }`

        if( hash ) return returnUrl

        return this.config.ReturnUrl || returnUrl
    }

    get changePasswordUrl() {
        return '/account/changepassword'
    }

    get getType() {
        const searchParams = new URLSearchParams( location.search )
        const type = searchParams.get( 'type' )
        return type
    }

    get getLoginTitle() {
        return this.config.loginTitle || undefined
    }

    get mfaAskMeAgainUrl() {
        return this.config.mfaAskMeAgainUrl || process.env.REACT_APP_MFA_URL_PAGE
    }

    get mfaAskMeAgainTimeOut() {
        return this.config.mfaAskMeAgainTimeOut ||  Number( process.env.REACT_APP_MFA_PERIOD_OF_TIME )
    }
 
    componentDidMount () {
        this._isMounted = true
        RememberMeAPI( { apiUrl: this.rememberMeUrl } )
        .then( ( webId ) => {
            if( this._isMounted && webId ){
                this.setState( { allowUserId: true , webId: webId, rememberMe: true } )
            }
        } )

      const type = this.getType
      const sufix = 'Sign In'

      const loginTitle = this.getLoginTitle

      if( type === 'municipal' ){
        this.setState( { enableSignUp : false, title: `Municipal Inspector ${ sufix }` } )
      }
      else if( type === 'contractor' ){
        this.setState( { enableSignUp : false, title: `Contractor ${ sufix }` } )
      }
      else if( type === 'dgcontractors' ){
        this.setState( { enableSignUp : false, title: `DG Contractor ${ sufix }` } )
      }
      else if( loginTitle ) {
        this.setState( { enableSignUp: false, title: loginTitle } )
      }
      else{
        this.setState( { enableSignUp : true, title: `Residential/Business ${ sufix }` } )
      }
    }

    componentWillUnmount() {
        this._isMounted = false
    }
    
    handleChangeUserId = e => {
        this.setState( { webId: e.target.value, allowUserId: e.target.value.length >= 3 && e.target.value.length <= 79 } )
    }
    handleChangePassword = e => {    
        this.setState( { password: e.target.value, passwordFormatError: null, errors: null, displayCompleteADAMsg : false } )
        passwordUtils.eyeColorValidation( 'password' , e.target.value )  
    }

    handleChangeRemember = e =>{
        this.setState( { rememberMe: e } )
    } 

    signInWithPKCE = async ( username, sessionToken ) => {
        let token = sessionToken
        
        try {            
            if ( !sessionToken ) {                
                throw new Error( 'Authentication process failed' )
            }
            
                const authTransaction = await this.props.oktaAuth.signInWithCredentials( { username, password: sessionToken } )
                if ( !authTransaction.sessionToken ) {                
                    throw new Error( 'Authentication process failed' )
                }

                token = authTransaction.sessionToken 
            
            const tokensTransaction = await this.props.oktaAuth.token.getWithoutPrompt( {
                responseType: 'id_token', 
                sessionToken: token
            } )
    
            this.props.oktaAuth.tokenManager.setTokens( tokensTransaction.tokens )
            trackEventMessage( new EventModel( LOGIN_PKCE.SUCCESS, username ) )
        } catch ( error ) {
            console.error( error )
            trackEventMessageFailure( new EventModel( LOGIN_PKCE.FAILURE, username ), error )
        }
    }
    validateMfaIsEnable = ( loginResponse, ffMfaEnableMessage, token, validMfaRememberMeData ) => {  
        const status = loginResponse.status
        const isMfaRequired = MFADomain.IsMfaRequired( status || []  )
        const isAskMeLaterPastDate = MFADomain.IsAskMeLaterPastDate()
        this.setState( { mfaStep: MFASteps.AskMeAgain } )

        if( !validMfaRememberMeData && ffMfaEnableMessage && isMfaRequired && isAskMeLaterPastDate ) {
            this.setState( { userId: token } )
            this.setState( { loginResponseReturnUrl: loginResponse.ReturnUrl } )
            this.setState( { factors: loginResponse.factors } )

            if( status ==  MFA_STATUS.MFA_REQUIRED ){                
                const phoneNumber = this.getPhoneNumberFromLoginResponse( loginResponse ) 
                this.setState( { phoneNumber: phoneNumber } )
                this.setState( { mfaStep: MFASteps.IssueFactor } )
            }

            this.setState( { showMFAWizard: true } )
        } else {
            MFADomain.RedirectToReturnUrl( loginResponse.ReturnUrl )
        }
    }

    getPhoneNumberFromLoginResponse = ( loginResponse ) => {
        const smsFactor = loginResponse.factors.filter( f => f.factorType == MFA.factorType.sms )
        if ( !smsFactor || smsFactor.length === 0  ) return ''

        return smsFactor[ 0 ].value
    }

    handleSubmit = async ( event ) => {
      if( event ) event.preventDefault()
        
      const { ldClient } = this.props
      const{ allowUserId, password } = this.state

      if( !password || password.length < 1 )
      {
        this.setState( { errors: { 'IncorrectPasswordFormat': '' }, displayCompleteADAMsg : false  } )
      }
      else
      {
        this.setState( { errors: null, displayCompleteADAMsg : false  } )
        if( allowUserId )
        {
            this.setState( { loading: true } ) 
            const { webId, rememberMe } = this.state

            setUserLoginValueOnSessionStorage( webId ) // save login username, could be actual okta username or profile email

            let returnUrl = this.returnUrl

            if ( returnUrl.toLowerCase().includes( this.changePasswordUrl ) ) {
                returnUrl = ''
            }
            
            try {      
                const mfaRememberMeData = getMfaRememberMeLocalStorageValue( webId )

                const loginResponse = await LogInAPI( {
                    webId: webId,
                    password: password,
                    rememberMe: rememberMe,
                    returnUrl: returnUrl,
                    apiUrl: this.logInApiUrl,
                    mfaRememberMeData: mfaRememberMeData || ''
                } )

                this.setState( { oktaUsername: loginResponse.OktaUsername } )

                if( loginResponse.IsSuccess ) { 

                    if( MFADomain.IsEnrolledToAnyFactor( loginResponse.factors ) ) {
                        removeAskMeLaterLocalStorageItem()
                    }

                    const profileEmailAddress = loginResponse.factors?.find( ( f ) => f.factorType === 'email' )?.value

                    const stateCode = getCookieValueByKey( PERSONALIZED_COOKIE_NAME, PersonalizedCookieStateCodeProperty )

                    const ffMfaEnableMessage = await refreshLDContextAndGetFFValue( profileEmailAddress, loginResponse.OktaUsername, stateCode, this.props.ldClient, FF_MFA_SHOW_MESSAGE_ENABLED )

                    if( !loginResponse.ValidMfaRememberMeData && ffMfaEnableMessage ) {
                        if( loginResponse.status != MFA_STATUS.MFA_REQUIRED )
                            await this.signInWithPKCE( loginResponse.OktaUsername, password )
                    } else {
                        await this.signInWithPKCE( loginResponse.OktaUsername, password )
                    }
                    
                    const token = loginResponse.token ? loginResponse.token : null 

                    const hashedOktaUserName = createSha256Hash( loginResponse.OktaUsername )

                    setMfaOktaUsernameLocalStorageValue( hashedOktaUserName )

                    MFADomain.setOktaEncryptedUserId( token )

                    trackEventMessage( new EventModel( LOGIN.SUCCESS, webId ) )  
        
                    this.validateMfaIsEnable( loginResponse, ffMfaEnableMessage, token, loginResponse.ValidMfaRememberMeData )

                    return { status: true, step: this.state.mfaStep } 
                }

                if( !loginResponse.IsSuccess && loginResponse.Errors ){
                    this.setState( { errors: loginResponse.Errors, loading: false } )
                    trackEventMessageFailure( new EventModel( LOGIN.FAILURE, webId ) )
                    return { status: false } 
                }
            } catch ( error ) {
                this.setState( { loading: false  } )
                this.setState( { mfaStep: MFASteps.ErrorMessagePage } )
                this.setState( { showMFAWizard: true } )
                AdobeAnalytics( [ error ] )
                trackEventMessageFailure( new EventModel( LOGIN.FAILURE, webId ), error )
                return { status: false } 
            }
            
        }
      }      
    }
    
    renderErrors = ( errors ) => {
        return Object.entries( errors ).map( ( [ key ] ) => {
            const error = this.getType && key === 'InvalidWebIdPassword' ? LogInErrors[ 'PartnerInvalidWebIdPassword' ] : LogInErrors[ key ] || 'Unexpected error.'
            if( !this.hasLoggedError && error ){
                if( !this.state.errorMessages.includes( error ) ) {
                    this.state.errorMessages.push( error )
                    AdobeAnalytics( this.state.errorMessages )
                    this.hasLoggedError = true
                }
            }
            if( error.includes( 'urlSignIn' ) )            {                
                const url = UrlBuilder( { url: this.registerUrl, buildURL: true } )
                return error.replace( '{urlSignIn}' , `<a href="${ url }" aria-label=""> Sign up</a>` )
            }
            else if( error.includes( 'urlForgotPassword' ) )            {
                const url = UrlBuilder( { url: this.forgotPasswordUrl, buildURL: true } )
                return error.replace( '{urlForgotPassword}' , `<a href="${ url }" aria-label=""> reset your password to continue.</a>` )
            }
            else{
                return error
            }
        } )
    }

    renderTextError = ( error ) => {
        return error.replace( /(<([^>]+)>)/gi , '' )
    }

    validateLength = _ => {
        const{ allowUserId, webId, password } = this.state
        if( webId.length > 0 || password.length > 0 )
        {
          if( !allowUserId ){            
              this.setState( { formatError: { 'IncorrectFormatLogIn': '' }, errors: null, displayCompleteADAMsg : false  } )              
          }
          else{
              this.setState( { errors: null, formatError: null, displayCompleteADAMsg : false } )
          }
        }
        else{
          this.setState( { errors: null, formatError: null, displayCompleteADAMsg : false } )
        }
    }
    
    render() {
        const{ errors, loading,
                  webId, password, rememberMe, enableSignUp, title, formatError, 
                  displayCompleteADAMsg, partialADAMsg, oktaUsername } = this.state
                  
        const adaMsg = displayCompleteADAMsg ? title + '.' + partialADAMsg :  partialADAMsg

        return (
            <>
                { !this.state.showMFAWizard ? <main className="c-main sign-in">
                    <div className="os-container--max-width">
                        <div className="c-form-card">
                            <div className="c-form-card__container">
                                <h1 className="o-heading-alpha" tabIndex="0">{ title }</h1>
                                <form onSubmit = { this.handleSubmit } name="loginForm">
                                    <div className="c-form-group">
                                        {
                                            errors ?
                                                <div className="c-form-error-message">                                                        
                                                    <img src={ ErrorMessageIcon } alt="Message Error" className="svg-form-error-message"/>
                                                    <p tabIndex="0"> { ReactHtmlParser( this.renderErrors( errors ) ) } </p>
                                                    <LiveAnnouncer>
                                                        <LiveMessage message= { this.renderTextError( this.renderErrors( errors )[ 0 ] ) } aria-live="polite" />
                                                    </LiveAnnouncer>
                                                </div>
                                                : null
                                            }
                                    </div>

                                    <div className="c-form-group">
                                        <TextInput labelText={ partialADAMsg } className="c-form-input" id="Email/Username" name="email" type="text" required
                                        value={ webId } onChange={ this.handleChangeUserId } onBlur= { ( e ) => { this.validateLength( e ); this.hasLoggedError = false } } maxLength="79"                                        
                                        autoFocus invalidText= { formatError ? this.renderErrors( formatError )[ 0 ] : '' }                                        
                                        invalid={ formatError ? true : false } aria-label={ adaMsg }
                                        />
                                    </div>

                                    <div className="c-form-group mb-3">
                                        <TextInput.PasswordInput
                                        labelText= "Password" 
                                        id="password"
                                        name="password"
                                        className="c-form-input"
                                        value={ password }
                                        onChange={ this.handleChangePassword }
                                        onBlur= { ( e ) => { this.validateLength( e ); this.hasLoggedError = false } }
                                        />
                                        <Link className="c-form-forgot-pass-link" href={ UrlBuilder( { url: this.forgotPasswordUrl, buildURL: true } ) }>Forgot your password?</Link>
                                    </div>
                                    <Checkbox labelText={ 'Remember my email or username' } checked={ rememberMe }  id="RememberMeID" className="mb-7" onChange= { this.handleChangeRemember }/>
                                    {
                                      loading ?
                                          <Loading
                                            description= { null } className="center-spinner" withOverlay={ false } small = { true }
                                          />
                                          :
                                          <Button className={ 'c-btn c-btn--primary mb-5' } type="submit" aria-label='Sign In Enabled' id="signIn" name="signIn">
                                              Sign In
                                          </Button>
                                    }
                                </form>
                            </div>
                            {
                              enableSignUp ? 
                                  <div className="c-form-card__call-out">
                                      <Link className="c-form-card__call-out-link" href={ UrlBuilder( { url: this.registerUrl, buildURL: true } ) }>
                                          Sign up for an online account
                                      </Link>
                                  </div>
                              : null
                            }
                        </div>
                        <LogInFooter
                          contractorsUrl= { this.contractorsUrl } 
                          municipalUrl= { this.municipalUrl }
                          dgContractorsUrl= { this.dgContractorsUrl }/>
                    </div>
                </main> : 
                <MfaWizard 
                    debounce={ this.state.debounce }        
                    returnUrl= { this.state.loginResponseReturnUrl }
                    mfaAskMeAgainTimeOut= { this.mfaAskMeAgainTimeOut }  
                    userId= { this.state.userId }
                    user= { {
                        webId: oktaUsername,
                        password: password,
                        rememberMe: rememberMe,
                        email: MFADomain.getEmailFactor( this.state.factors )
                    } }
                    mfaStep = { this.state.mfaStep }
                    phoneNumber = { this.state.phoneNumber }
                    factors = { this.state.factors }
                    errorLoginRequest = { { fn: this.handleSubmit, params: [ '' ], isLogin: true } }
                    onErrorRetry = { this.handleSubmit }
                    updateFactor = { ( factor ) => this.setState( { factors: MFADomain.setActiveFactor( factor, this.state.factors ) } ) }
                    setPhoneNumber = { ( value ) => this.setState( { phoneNumber: value } ) }
                    config = { this.config }
                    fromEditProfile = { false }
                /> }
            </>
        )
    }

    static propTypes = {
        config: PropTypes.shape( {
            logInUrl: PropTypes.string,
            logInApiUrl: PropTypes.string,
            forgotPasswordUrl: PropTypes.string,
            registerUrl: PropTypes.string,
            contractorsUrl: PropTypes.string,
            municipalUrl: PropTypes.string,
            dgContractorsUrl: PropTypes.string,
            ReturnUrl: PropTypes.string,
            loginTitle: PropTypes.string,
            mfaAskMeAgainTimeOut: PropTypes.number,
            antiForgeryHeaderName: PropTypes.string
        } ),
        oktaAuth: PropTypes.instanceOf( Object ),
        ldClient: PropTypes.instanceOf( Object ),
    }
} ) )
